import { useLanguage } from '../../i18n/LanguageContext';
import type { RequestQuote } from '../../services/dealerApi';
import Money from './Money';
import { fmt } from '../../utils/dealer';

/** Spec 085 (Flow B step 2) — face value, discount, amount payable, VAT, total due and validity. */
export default function QuoteCard({ quote }: { quote: RequestQuote }) {
  const { t } = useLanguage();
  return (
    <div className="dealer-card dealer-quote" data-testid="quote-card">
      <h3>{t('dealer.quote.title')}</h3>
      <dl className="dealer-dl">
        <dt>{t('dealer.quote.faceValue')}</dt><dd><Money value={quote.faceValueAed} /></dd>
        <dt>{t('dealer.quote.discount')}</dt><dd dir="ltr">{quote.discountPct}%</dd>
        <dt>{t('dealer.quote.payable')}</dt><dd><Money value={quote.payableAed} /></dd>
        <dt>{t('dealer.quote.vat')}</dt><dd><Money value={quote.vatAed} /></dd>
        <dt className="dealer-dl__total">{t('dealer.quote.totalDue')}</dt>
        <dd className="dealer-dl__total"><Money value={quote.totalDueAed} /></dd>
      </dl>
      <p className="dealer-muted">{fmt(t('dealer.quote.validity'), { months: quote.validityMonths })}</p>
    </div>
  );
}
